import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Image, Popover } from "antd";
// import { toast } from "react-toastify";
// import { getRequest } from "../../../api/http";
// import userServiceApi from "../../../api/userServiceApi";
import Logo from "../../../assets/images/PoweredNew.png";
import Leftarrow from "../../../assets/images/LeftArrow.svg";
import userProfile from "../../../assets/images/userProfile.svg";
import profileIcon from "../../../assets/images/profile-icon.svg";
import changepasswordIcon from "../../../assets/images/change-password-icon.svg";
import logoutIcon from "../../../assets/images/logout-icon.svg";
import "./index.scss";

function MicroSites() {
  const navigate = useNavigate();
  const [isShowProfile, setIsShowProfile] = useState(false);
  // const [partnerData, setPartnerData] = useState({});
  // const { micrositeId } = useParams();

  const showProfile = () => {
    setIsShowProfile(!isShowProfile);
  };

  const LogoutHandler = () => {
    sessionStorage.clear();
    window.location.reload();
  };

  // const getPartnerDetailsData = async () => {
  //   // console.log("APICall entry")
  //   try {
  //     // setLoading(true);
  //     const response = await getRequest(userServiceApi.partnerDetails());
  //     if (response && response.data) {
  //       setPartnerData(response.data);
  //     }
  //   } catch (error) {
  //     // setLoading(false);
  //     toast.error(error.error);
  //   }
  // };
  // useEffect(() => {
  //   // getPartnerDetailsData();
  // }, []);

  return (
    <div className="headerBannerRow">
      <div className="headerBannerCol">
        <div className="header-logo">
          <img
            style={{ cursor: "pointer" }}
            src={Logo}
            alt=""
            onClick={() =>
              window.open("https://www.connectsu.co.uk/", "_blank")
            }
          />
        </div>

        <div className="org-container">
          <div className="org-text">
            {/* <label className="org-name">
              {sessionStorage.getItem("OrgName")}
            </label> */}
            <label className="user-name"> User name</label>
            <label className="admin-name">Super Admin</label>
          </div>
          <Popover
            content={
              <div className="popover-content">
                <div className="dropdown-details">
                  <div
                    className="popover-single-content"
                    onClick={() => {
                      setIsShowProfile(false);
                      navigate("/admin");
                    }}
                  >
                    <img src={profileIcon} />
                    <h3>Home</h3>
                  </div>
                  <div
                    className="popover-single-content"
                    onClick={() => {
                      setIsShowProfile(false);
                      navigate("/change-password");
                    }}
                  >
                    <img src={changepasswordIcon} />
                    <h3>Change Password</h3>
                  </div>
                  <div
                    className="popover-single-content"
                    onClick={LogoutHandler}
                  >
                    <img src={logoutIcon} />
                    <h3>Logout</h3>
                  </div>
                </div>
              </div>
            }
            // title="Click title"
            trigger="click"
            open={isShowProfile}
            onOpenChange={showProfile}
            placement="bottomRight"
          >
            <img
              style={{ cursor: "pointer", margin: "10px" }}
              onClick={() => showProfile()}
              src={userProfile}
            />
          </Popover>
        </div>

        {/* {isShowProfile ?  : null} */}
      </div>
    </div>
  );
}
export default MicroSites;
